import { useContext, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Tooltip, ImageWithFallback } from '@components';
import { GlobalContext, UserPreferencesContext } from '@contexts';
import { legacyDashboardURL } from '@helpers';
import { BellIcon, HelpCircleIcon, MenuIcon, SettingsWhiteIcon } from '@svgs';

import './Header.scss';

export const Header = () => {
  const { t, i18n } = useTranslation();
  const globals = useContext(GlobalContext);
  const [userPreferences, setUserPreferences] = useContext(
    UserPreferencesContext,
  );

  // menu activation
  const dropdownMenu = useRef(null);
  const [showDropdownMenu, setShowDropdownMenu] = useState(false);
  const closeOpenMenus = (e) => {
    if (showDropdownMenu && !dropdownMenu.current?.contains(e.target)) {
      setShowDropdownMenu(false);
    }
  };
  document.addEventListener('mousedown', closeOpenMenus);

  // hamburger menu
  const toggleSidebar = (toggle) => {
    setUserPreferences({
      hideSidebar: toggle,
    });
  };
  return (
    <header className="sb-header">
      <div className="sb-container">
        <div className="sb-flex">
          <div className="sb-header-left">
            <div className="sb-flex">
              <Tooltip
                tooltip={
                  userPreferences.hideSidebar
                    ? 'Show sidebar menu'
                    : 'Hide sidebar menu'
                }
              >
                <button
                  onClick={() => toggleSidebar(!userPreferences.hideSidebar)}
                  className="sb-sidebar-button"
                >
                  <MenuIcon />
                </button>
              </Tooltip>
              <Link
                to={`/dashboard/projects`}
                className="sb-user sb-flex"
                title={t('Back to Home')}
              >
                <ImageWithFallback
                  src={`https://img.logo.dev/${globals.whitelabel.whitelabel_domain}?token=pk_O2Nfflm4QRmgnwGsI12jUQ`}
                  fallbackSrc={`https://img.logo.dev/devhub.com?token=pk_O2Nfflm4QRmgnwGsI12jUQ`}
                  alt={globals.whitelabel.partner_name}
                />
                <p>{globals.whitelabel.partner_name}</p>
              </Link>
            </div>
          </div>
          <div className="sb-header-right">
            <nav className="sb-flex sb-help-nav">
              <Tooltip tooltip="Get help and support">
                <a
                  href="https://support.devhub.com/hc/en-us/"
                  target="_blank"
                  aria-label="Get help and support"
                >
                  <HelpCircleIcon />
                </a>
              </Tooltip>
              {/*}
              <a href="https://www.devhub.com/" aria-label="DevHub Notifications">
                <BellIcon/>
              </a>
              */}
              <Tooltip tooltip="Your account">
                <Link
                  to={`/dashboard/settings/account`}
                  aria-label="Your account"
                >
                  <SettingsWhiteIcon />
                </Link>
              </Tooltip>
              <div className="sb-user-settings sb-options">
                <button
                  type="button"
                  className="sb-user-settings-button"
                  aria-label="User Menu"
                  onClick={() => setShowDropdownMenu(!showDropdownMenu)}
                >
                  {globals.user.first_name[0].toUpperCase()}
                </button>
                <div
                  ref={dropdownMenu}
                  className={
                    'sb-user-options-menu sb-options-menu ' +
                    (showDropdownMenu ? 'sb-show' : 'sb-hide')
                  }
                >
                  <div className="sb-options-menu-header sb-flex">
                    <div
                      className="sb-user-settings-button"
                      aria-label="User Menu"
                    >
                      {globals.user.first_name[0].toUpperCase()}
                    </div>
                    <div className="sb-user-settings-info">
                      <p className="sb-user-name">
                        {globals.user.first_name} {globals.user.last_name}
                      </p>
                      <p className="sb-user-email">{globals.user.email}</p>
                    </div>
                  </div>
                  <div className="sb-options-menu-content">
                    <Link
                      to={`/dashboard/settings/account`}
                      className="sb-options-item"
                    >
                      Account settings
                    </Link>
                    {globals.visible.legacyDashboardLink && (
                      <a
                        href={legacyDashboardURL('/app/')}
                        className="sb-options-item"
                      >
                        Switch to old dashboard
                      </a>
                    )}
                    <a
                      href="https://support.devhub.com/hc/en-us/"
                      target="_blank"
                      className="sb-options-item"
                    >
                      Get help
                    </a>
                    <a href="/accounts/signout/" className="sb-options-item">
                      Sign out
                    </a>
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};
